import React from 'react';
import './Whatsapp.css'; 

const WhatsApp = () => {
  return (
    <div className="whatsapp-button">
     <a href='https://wa.me/7259126513'> <img  style={{width:'110px'}} src="img/icon/waa.png" alt="WhatsApp" /></a>
    </div>
  );
}

export default WhatsApp;




